import React from 'react';
import Icon from 'components/lib/icons/icon';

export default function UnarchiveIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
        <path
          clipRule="evenodd"
          d="M4.19153 0C3.94432 0 3.70378 0.0877221 3.50601 0.25L0.459232 2.75C0.314117 2.86907 0.205692 3.01021 0.130745 3.16287C0.0495346 3.25177 0 3.3701 0 3.5V3.73732C0 3.73747 0 3.73761 0 3.73776V15.5C0 15.7761 0.223858 16 0.5 16H15.5C15.7761 16 16 15.7761 16 15.5V3.73857C16 3.73788 16 3.7372 16 3.73651V3.5C16 3.3701 15.9505 3.25177 15.8693 3.16287C15.7943 3.01021 15.6859 2.86907 15.5408 2.75L12.494 0.25C12.2962 0.0877225 12.0557 0 11.8085 0H4.19153ZM13.9412 3L11.8085 1.25L4.19153 1.25L2.05879 3H13.9412ZM8.00037 5C8.00012 5 7.99988 5 7.99963 5C7.85647 5.00009 7.71333 5.05384 7.60582 5.16123L4.15394 8.60956C3.81953 8.94362 4.06583 9.5 4.54812 9.5L6.66666 9.5L6.66666 12.7143C6.66666 13.4244 7.26362 14 7.99999 14C8.73637 14 9.33333 13.4244 9.33333 12.7143V9.5H11.4519C11.9342 9.5 12.1805 8.94362 11.8461 8.60956L8.39418 5.16123C8.28667 5.05384 8.14354 5.00009 8.00037 5Z"
          fill="#919191"
          fillRule="evenodd"
        />
      </svg>
    </Icon>
  );
}
